import { defineComponent as _defineComponent } from 'vue'
import './styles/map-viewer-state.scss';

export default /*#__PURE__*/_defineComponent({
  __name: 'MapViewerError',
  setup(__props) {


return { __sfc: true, }
}

})